module.exports = __webpack_public_path__ + "img/ph_left.32eb6778.jpg";